export class Page {
  constructor(public num: number) {}
}
